import React from 'react';
import { useIntl } from 'react-intl-next';
import Icon from '@atlaskit/icon';
import Tooltip from '@atlaskit/tooltip';
import { COMPONENT_TYPES } from './types';
import { IconBackground } from './styled';
export var ResultIcon = function ResultIcon(_ref) {
  var _COMPONENT_TYPES$type;
  var type = _ref.type,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size;
  var intl = useIntl();
  var componentType = (_COMPONENT_TYPES$type = COMPONENT_TYPES[type]) !== null && _COMPONENT_TYPES$type !== void 0 ? _COMPONENT_TYPES$type : COMPONENT_TYPES.OTHER;
  return /*#__PURE__*/React.createElement(Tooltip, {
    content: intl.formatMessage(componentType.message)
  }, /*#__PURE__*/React.createElement(IconBackground, {
    color: componentType.color,
    size: size
  }, /*#__PURE__*/React.createElement(Icon, {
    label: type,
    glyph: componentType.icon,
    size: size
  })));
};